/**
 * A customized base layer stylesheet.
 */
export class CustomizedStyle {
    constructor(emptyStyle, layers, lowestByType = {}) {
        this.lowestByType = {};
        this.emptyStyle = emptyStyle;
        this.layers = layers;
        this.lowestByType = lowestByType;
    }
    /**
     * Gets the lowest layer of the given type.
     */
    getLowestLayerOfType(type) {
        if (typeof type === "undefined")
            return undefined;
        return this.lowestByType[type];
    }
    /**
     * Gets the style sheet without any layers.
     *
     * @returns The style sheet without any layers.
     */
    getEmptyStyle() {
        return this.emptyStyle;
    }
    /**
     * Gets the layers.
     */
    getLayers() {
        return this.layers;
    }
}
